import useHttpLoader from '@/shared/hooks/useHttpLoader.ts'
import useStateWithChange from '@/shared/hooks/useStateWithChange.ts'
import mdmUtils from '@/pages/MDM/mdm.utils.ts'
import useNestedArrayChangeCallbacks from '@/shared/hooks/useNestedArrayChangeCallbacks.ts'
import mdmApi from '@/pages/MDM/mdm.api.ts'
import mdmEvents from '@/pages/MDM/events/mdm.events.ts'
import TextInput from '@/shared/Inputs/TextInput'
import TrashButton from '@/shared/Buttons/TrashButton'
import SidePage from '@/shared/SidePage'
import SeparateLine from '@/shared/Forms/SeparateLine'
import FormField from '@/shared/Forms/FormField'
import CreateEntityButton from '@/shared/Buttons/CreateEntityButton'
import Button from '@/shared/Buttons/Button'
import { IMDMUnitField } from '@/pages/MDM/mdm.types.ts'
import MDMDataTypeDropdown from '@/pages/MDM/components/MDMDataTypeDropdown'
import MDMValueInput from '@/pages/MDM/components/MDMValueInput'

interface IProps {
  onClose: () => void
  open: boolean
}

const CreateUnitSidePage = (props: IProps) => {
  const { wait, loading } = useHttpLoader()
  const [unit, setUnit, handleChange] = useStateWithChange(mdmUtils.generateCreateUnitDTO())

  const {
    handleCreateNewElement: handleValueCreate,
    handleElementUpdate: handleValueUpdate,
    handleElementDelete: handleValueDelete,
  } = useNestedArrayChangeCallbacks({
    sourceObjectSetter: setUnit,
    nestedArrayKey: 'fields',
    newEntityGenerator: () => mdmUtils.generateUnitField(unit.fields.length),
  })

  const handleCreate = () => {
    wait(mdmApi.createUnit(unit), (resp) => {
      if (resp.status === 'success') {
        mdmEvents.unitCreated(resp.body)
        props.onClose()
      }
    })
  }

  const renderField = (value: IMDMUnitField, index: number) => {
    return (
      <div className="flex-lines gap16">
        <div className="inline-flex-gap width100 flex-space-between">
          <h5 className="text-heading-5">Поле {index + 1}</h5>
          <TrashButton onClick={() => handleValueDelete(index)} />
        </div>
        <FormField label="Наименование" required={true}>
          <TextInput
            value={value.name}
            name="name"
            onChange={(val, name) => handleValueUpdate(index, val, name)}
            placeHolder="Введите наименование"
          />
        </FormField>
        <FormField label="Тип данных" required={true}>
          <MDMDataTypeDropdown
            value={value}
            onChange={(val) => {
              handleValueUpdate(index, val.type, 'type')
              handleValueUpdate(index, val.typeEnumId, 'typeEnumId')
            }}
          />
        </FormField>
        {value.type !== 'ENUM' && (
          <FormField label="Значение по умолчанию">
            <MDMValueInput
              value={value.defaultValue}
              schema={value as any}
              name="defaultValue"
              onChange={(val, name) => handleValueUpdate(index, val, name)}
              onUnitValueChange={() => {}}
              onEnumValueChange={() => {}}
              placeHolder="Введите значение по умолчанию"
            />
          </FormField>
        )}
      </div>
    )
  }

  return (
    <SidePage onClose={props.onClose} open={props.open} style={{ paddingBottom: 0 }}>
      <div className="flex-lines gap16 height100">
        <h4 className="text-heading-4">Создание агрегата</h4>
        <SeparateLine />
        <FormField label="Наименование" required={true}>
          <TextInput value={unit.name} name="name" onChange={handleChange} placeHolder="Введите наименование" />
        </FormField>
        <SeparateLine />
        <h5 className="text-heading-5">Значения</h5>
        {unit.fields.sort((a, b) => a.orderingIndex - b.orderingIndex).map(renderField)}
        <CreateEntityButton onClick={handleValueCreate} text="Добавить значение" type="default" fullWidth={true} />
        <div style={{ marginTop: 'auto' }}>
          <SeparateLine />
        </div>
        <div className="inline-flex-gap gap8" style={{ paddingBottom: '24px' }}>
          <Button
            size="default"
            type="primary"
            disabled={!unit.name}
            loading={loading}
            onClick={handleCreate}
            text="Создать"
          />
          <Button size="default" type="default" onClick={props.onClose} disabled={loading} text="Отмена" />
        </div>
      </div>
    </SidePage>
  )
}

export default CreateUnitSidePage
